"use strict";

var HTTP_METHODS = {
  POST: 'post',
  GET: 'get',
  FETCH: 'fetch',
  PUT: 'put',
  PATCH: 'patch',
  DELETE: 'delete'
};
module.exports = HTTP_METHODS;